/**
 * Context for entity change status actions (transferred / skipped).
 *
 * Provided at the detail page level so every card can consume it without
 * prop-drilling through section → card chains.
 */

import { createContext, useContext } from 'react';

import type { EntityChangeStatus } from '@/services/api/generated/entityChangesService';

export interface EntityChangeActionsContextValue {
  /** Update the status of a single entity change. */
  onStatusChange: (entityChangeId: string, newStatus: EntityChangeStatus) => void;
  /** Optimistic status overrides keyed by entity change ID. */
  statusOverrides: Record<string, EntityChangeStatus>;
}

const EntityChangeActionsContext =
  createContext<EntityChangeActionsContextValue | null>(null);

export const EntityChangeActionsProvider = EntityChangeActionsContext.Provider;

export function useEntityChangeActions(): EntityChangeActionsContextValue | null {
  return useContext(EntityChangeActionsContext);
}
